module.exports = __webpack_public_path__ + "img/Download-Notes-Icon.5997c817.svg";